
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, browserHistory } from "react-router-dom";
import { Provider } from "react-redux";
import Loadable from "react-loadable";
import "../css/bootstrap.css";
import "../css/style.css";
import "../css/react-grid-layout/css/styles.css";
import "../css/react-resizable/css/styles.css";
import "../css/react-grid-layout/css/styles.css";
import "../css/react-resizable/css/styles.css";
import ActionLoader from "./components/ActionLoader";

import Login from "./pages/Login";
import T from "i18n-react";

import store from "./store";
const Loading = () => <ActionLoader />;

const Layout = Loadable({
  loader: () => import("./pages/Layout"),
  loading: Loading
});
const login = Loadable({
  loader: () => import("./pages/Login"),
  loading: Loading
});
const Terms = Loadable({
  loader: () => import("./components/Terms"),
  loading: Loading
});
const PDFDisplay = Loadable({
  loader: () => import("./components/PDFDisplay"),
  loading: Loading
})
const Logout = Loadable({
  loader: () => import("./pages/Logout"),
  loading: Loading
});
T.setTexts(require(`../i18n/en.json`));
ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter basename={process.env.REACT_APP_ROUTER_BASE || ''}>
      <Switch>
    
        <Route exact path="/login" name="Login" component={Login} />
       

        <Route path="/logout" name="Logout Page" component={Logout} />
        <Route path="/" name="Home" component={Layout} />
      </Switch>
    </BrowserRouter>
  </Provider>
  /*<h1>Clientjs</h1>*/,
  app
); 
 
